// Client-side print/PDF of the IP plan (browser → "Save as PDF"). No backend.
import { openPrintWindow } from '@/lib/printWindow';
import { formatDateTime } from '@/utils/datetime';

function esc(s) {
  return String(s == null ? '' : s).replace(/[&<>]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;' }[c]));
}

/**
 * @param {Array<{name:string,subnet:string,total:number,assigned:number,entries:Array}>} groups
 * @param {string} title
 */
export function printIpPlan(groups, title = 'IP管理台帳') {
  const date = formatDateTime(new Date());
  const sections = groups.map((g) => `
    <h2>${esc(g.name)}<span class="sub">${esc(g.subnet || '')}　・　${g.assigned}/${g.total} 使用中</span></h2>
    <table>
      <thead><tr>
        <th>IPアドレス</th><th>使用者</th><th>デバイス名</th><th>接続</th><th>MACアドレス</th><th>用途</th>
      </tr></thead>
      <tbody>
        ${g.entries.length
          ? g.entries.map((e) => `<tr>
              <td class="mono">${esc(e.ip_address)}</td>
              <td>${esc(e.user)}</td>
              <td>${esc(e.device_name)}</td>
              <td>${esc(e.connection)}</td>
              <td class="mono">${esc(e.mac_address)}</td>
              <td>${esc(e.purpose)}</td>
            </tr>`).join('')
          : '<tr><td colspan="6" class="empty">割当なし</td></tr>'}
      </tbody>
    </table>`).join('');

  const html = `<!doctype html><html lang="ja"><head><meta charset="utf-8"><title>${esc(title)}</title>
  <style>
    *{box-sizing:border-box} body{font-family:'Noto Sans JP','Hiragino Sans',sans-serif;color:#0f172a;margin:24px}
    h1{font-size:18px;margin:0 0 4px} .meta{color:#64748b;font-size:11px;margin-bottom:16px}
    h2{font-size:13px;margin:18px 0 6px;border-left:4px solid #0052FF;padding-left:8px;display:flex;align-items:baseline;gap:8px}
    h2 .sub{font-weight:400;color:#64748b;font-size:11px}
    table{width:100%;border-collapse:collapse;font-size:11px;margin-bottom:8px}
    th{background:#0052FF;color:#fff;text-align:left;padding:5px 8px;font-weight:600}
    td{border:1px solid #e2e8f0;padding:4px 8px}
    tr:nth-child(even) td{background:#f8fafc}
    .mono{font-family:'IBM Plex Mono',monospace}
    .empty{text-align:center;color:#94a3b8;padding:10px}
    @media print{body{margin:12mm}}
  </style></head><body>
  <h1>${esc(title)} / IP Address Plan</h1>
  <div class="meta">株式会社センスビー　・　出力日時: ${esc(date)}</div>
  ${sections}
  </body></html>`;

  return !!openPrintWindow(html, { delay: 400 });
}
